import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import { token } from "functions/Helper";
import CreateMerchantInventoryGeneration from "views/MerchantInventoryGenerations/CreateMerchantInventoryGenerationList";
import DeleteMerchantInventoryGeneration from "views/MerchantInventoryGenerations/DeleteMerchantInventoryGeneration";
import EditMerchantInventoryGeneration from "views/MerchantInventoryGenerations/EditMerchantInventoryGeneration";
import GeneratedMerchantInventoryGenerationList from "views/MerchantInventoryGenerations/GeneratedMerchantInventoryGenrationsList";
import GenerateMerchantInventoryGeneration from "views/MerchantInventoryGenerations/GenerateMerchantInventoryGenerations";
import PendingMerchantInventoryGenerationList from "views/MerchantInventoryGenerations/PendingMerchantInventoryGenerationsList";
import ViewMerchantInventoryGeneration from "views/MerchantInventoryGenerations/ViewMerchantInventoryGeneration";

const merchantInventoryGeneration = () => {
  let views = [];

  if (
    token["travelagent.inventory_generation.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views = views.concat([
      {
        path: "/MerchantsProductGenerations/Pending",
        name: "Pending",
        mini: "PE",
        component: PendingMerchantInventoryGenerationList,
        layout: "/admin"
      },
      {
        path: "/MerchantsProductGenerations/Generated",
        name: "Generated",
        mini: "GE",
        component: GeneratedMerchantInventoryGenerationList,
        layout: "/admin"
      }
    ]);
  }

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "M Inventory Generations",
        icon: ConfirmationNumberIcon,
        state: "merchantInventoryGenerations",
        views: views
      }
    ];
  return [];
};

const merchantInventoryGenerationHidden = () => {
  let views = [];

  if (
    token["travelagent.inventory_generation.write"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views = views.concat([
      {
        path: "/MerchantInventoryGeneration/Create",
        name: "Create Merchant Inventory Generation",
        component: CreateMerchantInventoryGeneration,
        layout: "/admin"
      },
      {
        path: "/MerchantInventoryGeneration/Delete",
        name: "View Merchant Inventory Generation",
        component: DeleteMerchantInventoryGeneration,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/MerchantInventoryGeneration/Generate",
        name: "Generate Merchant Inventory Generation",
        component: GenerateMerchantInventoryGeneration,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/MerchantInventoryGeneration/Edit",
        name: "Edit Merchant Inventory Generation",
        component: EditMerchantInventoryGeneration,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      }
    ]);
  }

  if (
    token["travelagent.inventory_generation.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/MerchantInventoryGeneration/View",
      name: "View Merchant Inventory Generation",
      component: ViewMerchantInventoryGeneration,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  return [
    {
      collapse: true,
      name: "Merchant Inventory Generation",
      state: "merchantInventoryGenerationHidden",
      hideInSidebar: true,
      views
    }
  ];
};

export { merchantInventoryGeneration, merchantInventoryGenerationHidden };
